import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';
import AuthService from 'cio/services/auth';
import MomentService from 'cio/services/moment';
import BillingService from 'cio/services/billing';
import RouterService from '@ember/routing/router-service';
import { tracked } from '@glimmer/tracking';

export default class PostCancelController extends Controller {
  @service account!: AccountService;
  @service auth!: AuthService;
  @service moment!: MomentService;
  @service billing!: BillingService;
  @service router!: RouterService;

  queryParams = ['id'];
  @tracked id = '';

  logoColorHorizontalWhiteImage = new URL(
    'cio/assets/images/logo-color-horizontal-white.svg',
    import.meta.url,
  ).toString();

  @action
  logout() {
    return this.auth.logout(true);
  }
}
